var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable camelcase */
import Dialog from 'quasar/src/plugins/Dialog.js';;
const defaultOptions = {
    intendedAction: () => { console.error('Have you forgotten to add intendedAction?'); },
    title: 'Confirm action',
    message: 'Are you sure you want to do this?',
    dialogConfirmButtonText: 'Yes',
    dialogCancelButtonText: 'No'
};
export default function openDialogToConfirmIntendedAction(options) {
    return __awaiter(this, void 0, void 0, function* () {
        const { intendedAction, title, message, dialogConfirmButtonText, dialogCancelButtonText } = Object.assign(Object.assign({}, defaultOptions), options);
        const dialogProps = {
            title,
            message,
            persistent: true,
            focus: 'ok',
            transitionShow: 'slide-up',
            transitionHide: 'slide-down',
            ok: {
                label: dialogConfirmButtonText,
                unelevated: true,
                color: 'warning',
                class: 'default-action-button',
            },
            cancel: {
                label: dialogCancelButtonText,
                unelevated: true,
                color: 'info',
                class: 'cancel-button',
            }
        };
        Dialog.create(dialogProps).onOk(intendedAction);
    });
}
